import { render, staticRenderFns } from "./SefosMessage_4_2.vue?vue&type=template&id=34c0c03e&"
import script from "./SefosMessage_4_2.vue?vue&type=script&lang=js&"
export * from "./SefosMessage_4_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports